import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Gallery = () => {
    const [selectedImage, setSelectedImage] = useState(null);

    const images = [
        { id: 1, url: '/images/pic2.png', alt: 'photo1' },
        { id: 2, url: '/images/pic1.png', alt: 'photo12' },
        { id: 3, url: '/images/pic3.png', alt: 'photo3' },
        { id: 4, url: '/images/pic5.png', alt: 'photo4' },
        { id: 5, url: '/images/pic6.png', alt: 'photo5' },
        { id: 6, url: '/images/pic8.png', alt: 'photo6' }
    ];

    return (
        <section className="py-32 bg-white">
            <div className="container mx-auto px-4">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="text-center mb-20"
                >
                    <h2 className="text-4xl md:text-5xl font-serif text-wedding-accent mb-4">
                        Gallery
                    </h2>
                    <div className="w-16 h-[1px] bg-wedding-primary mx-auto"></div>
                </motion.div>

                <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-5xl mx-auto">
                    {images.map((image, index) => (
                        <motion.div
                            key={image.id}
                            className="relative overflow-hidden cursor-pointer group aspect-square bg-gray-100"
                            onClick={() => setSelectedImage(image)}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: index * 0.1 }}
                        >
                            <img
                                src={image.url}
                                alt={image.alt}
                                className={`w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 ${index === 0 || index === 4 || index === 3 ? 'object-right' : 'object-center'}`}
                                loading="lazy"
                            />
                            <div className="absolute inset-0 bg-wedding-accent/0 group-hover:bg-wedding-accent/20 transition-colors duration-500"></div>
                        </motion.div>
                    ))}
                </div>

                {/* Lightbox */}
                <AnimatePresence>
                    {selectedImage && (
                        <motion.div
                            className="fixed inset-0 bg-white z-50 flex items-center justify-center p-4 cursor-pointer"
                            onClick={() => setSelectedImage(null)}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                        >
                            <button
                                className="absolute top-8 right-8 text-wedding-accent text-3xl hover:text-wedding-primary transition-colors w-10 h-10 flex items-center justify-center"
                                onClick={() => setSelectedImage(null)}
                            >
                                ×
                            </button>
                            <motion.img
                                src={selectedImage.url}
                                alt={selectedImage.alt}
                                className="max-w-full max-h-[85vh] object-contain"
                                initial={{ scale: 0.9, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                exit={{ scale: 0.9, opacity: 0 }}
                                transition={{ duration: 0.3 }}
                            />
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>
        </section>
    );
};

export default Gallery;
